import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TemplateOptionsMenu from 'Components/UI/TemplateOptionsMenu';
import { TemplatesProvider } from 'Context/TemplateContext';
import { noop } from 'Helpers/PropTypes';
import {
  RichTextEditorInputFieldSkeleton,
} from 'Components/ComponentLibrary/Components/Uncategorized/RichTextEditorInputField/components/RichTextEditorInputFieldSkeleton';
import RichTextEditor from 'Components/UI/RichTextEditor';
import useUserContext from 'Context/UserContext';

const useStyles = buildUseStyles('RichTextEditorWithTemplateTokens', (theme) => ({
  root: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    top: theme.spacing(0.25),
    right: theme.spacing(1),
    position: 'absolute',
    height: theme.spacing(4.5), // 36px is CKEditor toolbar height
  },
  templateButton: {
    padding: theme.spacing(1),
  },
}));

const RichTextEditorWithTemplateTokens = ({
  className,
  onChange,
  disabled,
  value,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [isLoading, setLoading] = useState(true);
  const { isAgent } = useUserContext();

  // This appends a template or token that is selected and passed in as HTML
  const appendHTMLTemplate = (content) => {
    const newHtml = value + content;
    onChange(newHtml);
  };

  return (
    <Box className={classNames(className, classes.root)}>
      {isLoading && <RichTextEditorInputFieldSkeleton height={200} />}
      <Box>
        <RichTextEditor
          onChange={(val) => onChange(val)}
          onLoaded={() => setLoading(false)}
          value={value}
          disabled={disabled}
        />
        {!isLoading && isAgent
          ? (
            <Box className={classes.toolbar}>
              <TemplatesProvider>
                <TemplateOptionsMenu
                  showTokenMenuOptionOnly
                  useLegacyButton
                  onInsertToken={(token) => appendHTMLTemplate(token)}
                  ButtonProps={{
                    className: classes.templateButton,
                  }}
                />
              </TemplatesProvider>
            </Box>) : null}
      </Box>
    </Box>
  );
};

RichTextEditorWithTemplateTokens.defaultProps = {
  className: '',
  onChange: noop,
  disabled: false,
  value: '',
};

RichTextEditorWithTemplateTokens.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string,
};

export { RichTextEditorWithTemplateTokens };
